import React, { Component } from 'react';
import MailCheck from 'react-mailcheck';

class EmailSuggestion extends Component {
  constructor(props) {
    super(props);

    this.useSuggestion = this.useSuggestion.bind(this);
  }

  useSuggestion() {
    const suggestion = this.mailcheck.state.suggestion.full;
    this.props.useSuggestion(suggestion);
  }

  render() {
    const { email } = this.props;
    if (!email) { return null; }

    return (
      <MailCheck ref={(mailcheck) => { this.mailcheck = mailcheck; }} email={email}>
        {(suggestion) => {
          if (suggestion) {
            return (
              <div className="email-suggestion text-size-12">
                Did you mean {<span className="clickable suggestion-value" onClick={this.useSuggestion}>{suggestion.full}</span>}?
              </div>
            );
          }

          return null;
        }}
      </MailCheck>
    );
  }
}

export default EmailSuggestion;
